export default __webpack_public_path__ + "static/media/logo512.4fc85ba5.png";